export const storageKeys = {
  currentCommunityId: '@totzeret_current_community_id',
  currentGroupId: '@totzeret_current_group_id',
  currentTab: '@totzeret_current_tab',
  LANG: '@TOTZERET_ADMIN_LANG',
  tokenCommunity: '@totzeret_token_community',//if user managed to login iframe with token
  token: '@totzeret_token',
  resendCooldown: '@totzeret_resend_cooldown'//escalating cooldown state for verification-code resend
}

const veryLocalStorage = {
  set(key: string, value: any): void {
    const toSave = JSON.stringify(value)
    localStorage.setItem(key, toSave)
  },
  get(key: string): any {
    try {
      const data = localStorage.getItem(key)
      if (!data) return false
      const json = JSON.parse(data)
      return json
    } catch {
      return false
    }
  },
  remove(key: string): void {
    localStorage.removeItem(key)
  },
  clear(): void {
    Object.values(storageKeys).forEach(key => veryLocalStorage.remove(key))
  }
}

export default veryLocalStorage
